import log from 'salvo-lite/log'

class ProductGridItem {
    constructor (theme, elem) {
        this._elem = elem
    }

    onInit () {
        this._changeHoverImageDimension()

        log.debug(this.constructor.name, 'Initiating', this)
    }

    _changeHoverImageDimension () {
        let _mainImgHeight = this._elem.querySelector('.bg-area').offsetHeight
        let _mainImgWidth = this._elem.querySelector('.bg-area').offsetWidth
        let _hoverImage = this._elem.querySelector('.bg_hover-img')

        if (_mainImgHeight != null && _hoverImage != null) {
            _hoverImage.setAttribute('height', _mainImgHeight)
        }
        if (_mainImgWidth != null && _hoverImage != null) {
            _hoverImage.setAttribute('width', _mainImgWidth)
        }
    }
}

export default ProductGridItem



// WEBPACK FOOTER //
// ./src/resources/scripts/components/Product-grid-item.js